import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../../components/ui/Header';
import AuthTabs from './components/AuthTabs';
import LoginForm from './components/LoginForm';
import RegisterForm from './components/RegisterForm';
import SocialLogin from './components/SocialLogin';
import GuestCheckout from './components/GuestCheckout';
import Icon from '../../components/AppIcon';

const UserAuthenticationLoginRegister = () => {
  const [activeTab, setActiveTab] = useState('login');
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check if user is already logged in
    const authToken = localStorage.getItem('authToken');
    if (authToken) {
      navigate('/homepage-dashboard');
      return;
    }

    // Store return URL for redirect after login
    const returnUrl = new URLSearchParams(location.search).get('returnUrl');
    if (returnUrl) {
      localStorage.setItem('returnUrl', returnUrl);
    }
  }, [navigate, location]);

  const handleAuthSuccess = () => {
    setShowSuccessMessage(true);
    setTimeout(() => {
      setShowSuccessMessage(false);
    }, 3000);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setShowSuccessMessage(false);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="pt-16 lg:pt-18">
        <div className="min-h-screen flex items-center justify-center px-4 py-8">
          <div className="w-full max-w-md">
            {/* Logo and Welcome Message */}
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-primary rounded-full mb-4">
                <Icon name="ShoppingCart" size={32} color="white" />
              </div>
              <h1 className="font-heading font-heading-bold text-2xl text-text-primary mb-2">
                Welcome to FreshCart
              </h1>
              <p className="text-text-secondary">
                {activeTab === 'login' ?'Sign in to your account to continue shopping' :'Create your account to start shopping fresh groceries'
                }
              </p>
            </div>

            {/* Success Message */}
            {showSuccessMessage && (
              <div className="mb-6 p-4 bg-success/10 border border-success/20 rounded-card animate-slide-down">
                <div className="flex items-center space-x-2">
                  <Icon name="CheckCircle" size={20} className="text-success" />
                  <p className="text-success font-body-semibold">
                    {activeTab === 'login' ? 'Successfully signed in!' : 'Account created successfully!'}
                  </p>
                </div>
              </div>
            )}

            {/* Authentication Card */}
            <div className="bg-surface rounded-card shadow-card p-6 border border-border">
              {/* Tab Navigation */}
              <AuthTabs activeTab={activeTab} onTabChange={handleTabChange} />

              {/* Form Content */}
              <div className="space-y-6">
                {activeTab === 'login' ? (
                  <LoginForm onSuccess={handleAuthSuccess} />
                ) : (
                  <RegisterForm onSuccess={handleAuthSuccess} />
                )}

                {/* Social Login */}
                <SocialLogin onSuccess={handleAuthSuccess} />
              </div>
            </div>

            {/* Guest Checkout Option */}
            <div className="mt-6">
              <div className="bg-surface rounded-card shadow-card border border-border">
                <GuestCheckout />
              </div>
            </div>

            {/* Footer Links */}
            <div className="mt-8 text-center space-y-2">
              <p className="text-text-secondary text-sm">
                By continuing, you agree to our{' '}
                <button className="text-primary hover:text-primary/80 transition-smooth">
                  Terms of Service
                </button>
                {' '}and{' '}
                <button className="text-primary hover:text-primary/80 transition-smooth">
                  Privacy Policy
                </button>
              </p>
              <div className="flex items-center justify-center space-x-4 text-sm">
                <button className="text-text-secondary hover:text-primary transition-smooth">
                  Help Center
                </button>
                <span className="text-border">•</span>
                <button className="text-text-secondary hover:text-primary transition-smooth">
                  Contact Support
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default UserAuthenticationLoginRegister;